<template>
<main>
    <section class="min-vh-100 d-flex align-items-center position-relative">
        <div class="container-xl">
            <transition name="component-fade" mode="out-in">
            <div class="row" v-if="data">
                <div class="col-md-7 d-flex flex-column justify-content-center mb-md-0 mb-3">
                    <img class="mw-100 img-contain" style="max-height: 75vh" :src="data.url">
                </div>
                <div class="col-md-5 text-md-justify text-center text-white d-flex flex-column justify-content-center py-5">
                    <h1 class="text-primary font-weight-bold" style="font-size: 30px">Tarot</h1>
                    <div class="content" v-html="data.content"></div>
                </div>
            </div>
            </transition>
        </div>
    </section>
</main>
</template>

<script>
    export default {
        data(){
            return {
                data: null,
            }
        },
        mounted(){
            axios
            .get('/home/get', {
                params:
                {
                    'option': 'tarot',
                }
            }).then(response => {

                this.data = response.data;
            });
        }
    }
</script>
